/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import _ from "lodash";
import useDidMountEffect from "lib/react/customHooks";
import SliderComponent from "./SliderComponent";
import NumberComponent from "./NumberComponent";
import ChosenGridComponent from "./ChosenGridComponent";
import ScenarioNameComponent from "./ScenarioNameComponent";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#fafafa",
    flexGrow: "1",
  },
  constraintContainer: {
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderRadius: "3px",
    marginBottom: "5px",
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    padding: "12px",
  },
}));

export default function ScenarioMapConstraintsComponent({
  constraints,
  constraintRanges,
  setNewScenarioName,
  newScenarioName,
  newScenarioComment,
  setNewScenarioComment,
  filters,
  setConstraints,
  scenarioMapSelectedScenario,
  scenarioMapReferenceScenario,
  invalidName,
  invalidcharacter,
  invalidcharacterInCommment,
  metadata,
}) {
  const classes = useStyles();
  const [inputTexts, setInputTexts] = useState(constraintRanges);

  useDidMountEffect(() => {
    if (!_.isEmpty(scenarioMapSelectedScenario))
      setNewScenarioName(
        scenarioMapSelectedScenario.scenario.scenario_type_id === 3 ||
          scenarioMapSelectedScenario.scenario.scenario_type_id === 1
          ? `Copy of ${scenarioMapSelectedScenario.scenario.name}`
          : `Copy of Scenario ${scenarioMapSelectedScenario.scenario.id}`
      );
  }, [scenarioMapSelectedScenario]);

  useDidMountEffect(() => {
    setInputTexts(constraintRanges);
  }, [constraintRanges]);

  const handleChange = (key, value) => {
    setConstraints({
      ...constraints,
      [key]: value,
    });

    setInputTexts({
      ...inputTexts,
      [key]: value,
    });
  };

  const handleTextInputChange = (key, value) => {
    setInputTexts({
      ...inputTexts,
      [key]: value,
    });
  };

  const handleBlur = (key, index) => {
    let newValue = Number(inputTexts[key][index]);
    newValue =
      newValue < Number(constraintRanges[key][0])
        ? Number(constraintRanges[key][0])
        : newValue;

    newValue =
      newValue > Number(constraintRanges[key][1])
        ? Number(constraintRanges[key][1])
        : newValue;

    if (Number.isNaN(newValue)) return;

    if (index === 0) {
      newValue =
        newValue > constraints[key][1] ? constraints[key][1] : newValue;
      handleChange(key, [newValue, constraints[key][1]]);
    } else if (index === 1) {
      newValue =
        newValue < constraints[key][0] ? constraints[key][0] : newValue;
      handleChange(key, [constraints[key][0], newValue]);
    }
  };

  return (
    <div className={classes.root}>
      {!_.isEmpty(scenarioMapSelectedScenario) ? (
        <Box component="div" className={`${classes.constraintContainer}`}>
          <ScenarioNameComponent
            scenarioTotal={scenarioMapSelectedScenario}
            newScenarioName={newScenarioName}
            setNewScenarioName={setNewScenarioName}
            newScenarioComment={newScenarioComment}
            setNewScenarioComment={setNewScenarioComment}
            invalidName={invalidName}
            invalidcharacter={invalidcharacter}
            invalidcharacterInCommment={invalidcharacterInCommment}
          />
        </Box>
      ) : null}
      <ChosenGridComponent
        scenarioMapSelectedScenario={scenarioMapSelectedScenario}
        scenarioMapReferenceScenario={scenarioMapReferenceScenario}
        metadata={metadata}
        constraints={constraints}
        filters={filters}
      />
      <NumberComponent
        inputData={{
          key:
            metadata.all.investment_in[0].visibility_type === 2
              ? "totalInvestmentIn"
              : "totalInvestment",
          label: "Max. Investment",
          unit: "$",
          description:
            "The investment allowed for promotions in terms of price out.",
        }}
        constraints={constraints}
        handleTextInputChange={handleTextInputChange}
        handleBlur={handleBlur}
        inputTexts={inputTexts}
        handleChange={handleChange}
      />

      <SliderComponent
        inputData={{
          key: "priceRange",
          label: `Discount offered range`,
          minValue: constraintRanges.priceRange[0],
          maxValue: constraintRanges.priceRange[1],
          unit: "%",
          description: `The Discount offered range allowed for every product in the portfolio.`,
        }}
        constraints={constraints}
        handleTextInputChange={handleTextInputChange}
        handleBlur={handleBlur}
        inputTexts={inputTexts}
        handleChange={handleChange}
      />
      {/* <SliderComponent
        inputData={{
          key: "unitsRange",
          label: `Desired Volume Increase range`,
          minValue: constraintRanges.unitsRange[0],
          maxValue: constraintRanges.unitsRange[1],
          unit: "%",
          description: `The Desired Volume Increase loss/profit allowed for the selected scope.`,
        }}
        constraints={constraints}
        handleTextInputChange={handleTextInputChange}
        handleBlur={handleBlur}
        inputTexts={inputTexts}
        handleChange={handleChange}
      />
      <SliderComponent
        inputData={{
          key: "marginRange",
          label: "Desired Margin Increase",
          minValue: constraintRanges.marginRange[0],
          maxValue: constraintRanges.marginRange[1],
          unit: "%",
          description: "The margin loss/profit allowed for the selected scope.",
        }}
        constraints={constraints}
        handleTextInputChange={handleTextInputChange}
        handleBlur={handleBlur}
        inputTexts={inputTexts}
        handleChange={handleChange}
      /> */}
      {/* <ToggleComponent
        inputData={{
          key: "samePriceToggle",
          label: "Same price daily",
          description:
            "Force products to have the same price every day of the promotional cycle."
        }}
        constraints={constraints}
        handleChange={handleChange}
      /> */}
    </div>
  );
}
